/**
 * Takes a string and returns the capitalized version of it
 * @param s String to capitalize
 * @returns String with capitalized first letter
 */
export function capitalizeFirstLetter(s?: string): string {
  if (!s) {
    return '';
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Takes a string and returns the truncated version (if necessary)
 * @param s String to truncate
 * @returns String that is truncated
 */
export interface ITruncateOptions {
  maxLength?: number;
  ellipsis?: boolean;
}
const defaultTruncateOptions: ITruncateOptions = {
  maxLength: 15,
  ellipsis: true,
};
export function truncate(s: string, options?: ITruncateOptions): string {
  if (!s) {
    return '';
  }
  let r = s;

  // initialize options
  const opt = {
    ...defaultTruncateOptions,
    ...options,
  };

  if (opt.maxLength && opt.maxLength < r.length) {
    r = r.slice(0, opt.maxLength);

    if (opt.ellipsis) {
      r += '...';
    }
  }

  return r;
}
